module.exports = __webpack_public_path__ + "static/media/next-control-carousel-active.d2c4962f.svg";